// TODO: figureout what to do with a copy here apps/routing/src/routes/_secured/campaign/$campaignId/planning/buying-plan/index.tsx

export const PanelTab = {
  AddRow: 'AddRow',
  Recommendations: 'Recommendations',
  Co2: 'Co2',
  Versions: 'Versions',
} as const;

export type PanelTab = (typeof PanelTab)[keyof typeof PanelTab];
